import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../utils";
import { TtOrderSnapshot } from "./types";

export function useListCurrentSnapshots(options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "snapshots"],
        queryFn: () => fetchApiGet<{ snapshots: TtOrderSnapshot[]; snapshot_id: string | null }>(
            "/brokerage/tt/events/snapshots"
        ),
        enabled: options?.enabled ?? true,
    });
}

export function useGetSnapshotByGuid(guidOrderId: string, options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "snapshot", guidOrderId],
        queryFn: () => fetchApiGet<{ snapshot: TtOrderSnapshot | null }>(
            `/brokerage/tt/events/snapshots/byGuidOrderId/${encodeURIComponent(guidOrderId)}`
        ),
        enabled: (options?.enabled ?? true) && !!guidOrderId,
    });
}
